export const FETCH_BRAND_HS_CUSTOM_FIELDS_START = 'FETCH_BRAND_HS_CUSTOM_FIELDS_START'
export const FETCH_BRAND_HS_CUSTOM_FIELDS_SUCCESS = 'FETCH_BRAND_HS_CUSTOM_FIELDS_SUCCESS'
export const FETCH_BRAND_HS_CUSTOM_FIELDS_FAILURE = 'FETCH_BRAND_HS_CUSTOM_FIELDS_FAILURE'

export const SAVE_BRAND_HS_CUSTOM_FIELDS_START = 'SAVE_BRAND_HS_CUSTOM_FIELDS_START'
export const SAVE_BRAND_HS_CUSTOM_FIELDS_SUCCESS = 'SAVE_BRAND_HS_CUSTOM_FIELDS_SUCCESS'
export const SAVE_BRAND_HS_CUSTOM_FIELDS_FAILURE = 'SAVE_BRAND_HS_CUSTOM_FIELDS_FAILURE'
export const RESET_BRAND_HS_CUSTOM_FIELDS_SAVE = 'RESET_BRAND_HS_CUSTOM_FIELDS_SAVE'
